import apiClient from '../apiClient';
import { POST_TRANSPORTATION_UNIT_HEADER_URL } from '../apiUrl';

const postTransportationUnitHeaderApi = data => {
  return apiClient.post(POST_TRANSPORTATION_UNIT_HEADER_URL, data);
};

export default postTransportationUnitHeaderApi;
